// SIAMO DENTRO L'APP NATIVA? (2026-09-15)
//
// Lo diciamo dallo USER AGENT, non da Capacitor.isNativePlatform(): l'app
// carica il sito REMOTO nel suo WebView (server.url), e in quel contesto
// isNativePlatform() puo' tornare false — cioe' il sito si comporta come se
// fosse il web anche dentro l'app. L'app invece aggiunge sempre
// "LifetimeCloudApp/<versione>" allo user agent (android, capacitor.config.json
// -> appendUserAgent), quindi questo segnale c'e' comunque.
//
// Serve soprattutto a NON mostrare inviti all'acquisto dentro l'app: un
// pagamento fuori dalla fatturazione di Google e' il motivo di rifiuto piu'
// comune sul Play Store, e l'app e' in revisione.
export function dentroApp() {
  try {
    return (navigator.userAgent || '').includes('LifetimeCloudApp');
  } catch {
    return false;
  }
}
